import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardActionArea, Typography, Button } from "@mui/material";
import { QrCodeScanner, LocalShipping, History } from "@mui/icons-material";

import PageHeader from "../../components/common/PageHeader";

const MODES = [
  {
    mode: "in",
    label: "Scan In",
    description: "Confirm packages arriving at the Cayman warehouse after customs clearance",
    icon: <QrCodeScanner sx={{ fontSize: 40 }} />,
  },
  {
    mode: "out",
    label: "Scan Out",
    description: "Confirm packages leaving the warehouse, scheduled for delivery",
    icon: <LocalShipping sx={{ fontSize: 40 }} />,
  },
];

// Landing page for the warehouse barcode scanner — picks which direction
// (in/out) before opening the camera, since each defaults to a different
// target status but otherwise shares the exact same scan flow (see
// AdminScan.jsx).
const AdminWarehouseScan = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
        <PageHeader title="Warehouse Scan" subtitle="Scan a package's tracking barcode to update its status" />
        <Button
          startIcon={<History />}
          variant="outlined"
          size="small"
          onClick={() => navigate("/admin/scan/log")}
          sx={{ flexShrink: 0 }}
        >
          View Scan Log
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          flexWrap: "wrap",
          py: 4,
        }}
      >
        {MODES.map((m) => (
          <Card key={m.mode} sx={{ width: 260 }}>
            <CardActionArea
              onClick={() => navigate(`/admin/scan/${m.mode}`)}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1.5,
                py: 5,
                px: 3,
                textAlign: "center",
              }}
            >
              {m.icon}
              <Typography variant="h6" fontWeight={700}>
                {m.label}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {m.description}
              </Typography>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default AdminWarehouseScan;
